// extracted by mini-css-extract-plugin
module.exports = {"dialog-upload":"dialog-upload-940007eb22015dcafa9b18eb11ef910b"};